import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountUserListQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countUsers(options: { filters: $filters })
      }
    }
  }
`
